import { createVNode as n, mergeProps as w } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowDownTwoTone.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(s, w(t, {
    icon: m
  }), null);
};
o.displayName = "ArrowDownTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
